import React, {useEffect, useState} from 'react';
import {Link, useLocation} from "react-router-dom";
import HeaderLogo from '../../components/HeaderLogo'
import Button from '../../components/Button';

import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';

const servicelink = {
  withTiles: {
    id: 68,
    floor:{
      id: 218,
      inspection: {
        id: 929
      }
    },
    ceiling: {
      id: 219,
      inspection: {
        id: 935
      }
    }
  },
  noTiles: {
    id: 70,
    floor:{
      id: 221,
      inspection: {
        id: 947
      }
    },
    ceiling: {
      id: 222,
      inspection: {
        id: 953
      }
    }
  }
}

function WithtilesInspection({details, selectedTile, selectedYaneaw}) {
  const [open, setOpen] = useState(false);
  const [bookingLink, setBookingLink] = useState('https://24fix.co/booking/step-1')
  const location = useLocation();
  useEffect(()=>{
    let link = generateLink(bookingLink)
    setBookingLink(link)
    console.log(details)
  },[])

  function generateLink(link){
    let note = "&note="
    if(details?.notile){
      link += '?c=' + servicelink.noTiles.id
      note += 'เลือกกระเบื้อง+หาช่าง'
      if(details?.areaType==='floor'){
        link += '&s=' + servicelink.noTiles.floor.id
        link += '&vnum=1&v0qty=1&v0id=' + servicelink.noTiles.floor.inspection.id
        note += '-กระเบื้องพื้น-สำรวจหน้างาน'
      }
      else if(details?.areaType==='ceiling'){
        link += '&s=' + servicelink.noTiles.ceiling.id
        link += '&vnum=1&v0qty=1&v0id=' + servicelink.noTiles.ceiling.inspection.id
        note += '-กระเบื้องผนัง-สำรวจหน้างาน'
      }
      note += '-กระเบื้อง_'+selectedTile.name
      note += '-ยาแนว_'+selectedYaneaw.name
    }
    else{
      link += '?c=' + servicelink.withTiles.id
      note += 'หาช่าง'
      if(details?.areaType==='floor'){
        link += '&s=' + servicelink.withTiles.floor.id
        link += '&vnum=1&v0qty=1&v0id=' + servicelink.withTiles.floor.inspection.id
        note += '-กระเบื้องพื้น-สำรวจหน้างาน'
      }
      else if(details?.areaType==='ceiling'){
        link += '&s=' + servicelink.withTiles.ceiling.id
        link += '&vnum=1&v0qty=1&v0id=' + servicelink.withTiles.ceiling.inspection.id
        note += '-กระเบื้องผนัง-สำรวจหน้างาน'
      }
    }
    link += note
    return link
  }

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="page-container">
        <Modal
          open={open}
          onClose={handleClose}
        >
          <div className='contact-modal'>
            <h2 id="simple-modal-title">ระบุข้อมูลเพื่อให้ติดต่อกลับ</h2>
            <div>
              <div>ชื่อผู้ติดต่อ</div>
              <TextField id="outlined-basic" variant="outlined" size="small" compact />
            </div>
            <div>
              <div>เบอร์โทรศัพท์</div>
              <TextField id="outlined-basic" variant="outlined" size="small" compact />
            </div>
            <Button variant="contained">ส่งข้อมูล</Button>
          </div>
        </Modal>
        <HeaderLogo />

        <div className="flex row mainpadding">
            <Link to={
              location.pathname === "/tiles/notiles/inspection"
                ?"/tiles/notiles/question"
                :"/tiles/withtiles/question"
              } 
              className="back-button"
            >
                <div>{'< กลับไปกรอกข้อมูลเพิ่ม'}</div>
            </Link>
        </div>
        <div className="inspection-title-card">
            {/* <div className="cover-header-container green-bg box-shadow h3">สำรวจพื้นที่</div>         */}
            <div className="floating-kay" style={{bottom: 0, top: 'unset'}}>
                <img className="kay-container" src="/asset/kay.png" />
            </div>
        </div>


        <div className="mainpadding">
          <div className="h1 bold">บริการประเมินราคาหน้างาน</div>
          <div className="h4 grey-text alight-left">เนื่องจากข้อมูลยังไม่เพียงพอที่ระบบจะคำนวณราคาได้ ทางเราจึงขอแนะนำให้ทำการสำรวจพื้นที่หน้างานก่อน เพื่อการประเมินราคาที่ถูกต้อง</div>
          <div className="h4 alight-left">
          <br/>
          ข้อมูลที่ไม่ทราบ
          <br/>
          {
            details?.areaSize===""||details?.areaSize==="nodata"?<span className="grey-text">- ขนาดพื้นที่</span>:null
          }
          </div>
        </div>
        <div className="mainpadding">
          <a 
            href={bookingLink} 
            target="_blank"
            style={{width: '100%'}}
          >
            <Button 
            variant="contained" 
            text="จองช่างประเมินราคา >" 
            fullWidth
            bigText
            />
          </a>
          <div className="h6"><br/></div>
          <div className="flex row">
            <a 
            href="https://line.me/R/ti/p/%40372nmsnv" 
            target="_blank"
            style={{width: '100%'}}
            className="line-button"
            >
              <Button 
              variant="contained" 
              text="แอดไลน์สอบถาม" 
              fullWidth
              backgroundColor="#00b900"
              startIcon={<img src="/asset/lineicon.png" style={{width: '30px', height: '30px'}} />}
              />
            </a>
            {/* <div style={{width: '10px'}}></div> */}
            {/* <Button 
            variant="contained" 
            text="ให้แอดมินติดต่อกลับ" 
            startIcon={<img src="/asset/customer-service1.png" style={{width: '30px'}} />}
            fullWidth
            backgroundColor="#2227bd"
            onPress={handleOpen}
            /> */}
          </div>
        </div>
    </div>
  );
}

export default WithtilesInspection;
